import { render, staticRenderFns } from "./Model15.vue?vue&type=template&id=1451b55f&scoped=true&"
import script from "./Model15.vue?vue&type=script&lang=js&"
export * from "./Model15.vue?vue&type=script&lang=js&"
import style0 from "./Model15.vue?vue&type=style&index=0&id=1451b55f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1451b55f",
  null
  
)

export default component.exports